import React from 'react'
import {Modal} from 'antd'
import {responsive, breakpoints} from '../../core/style'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import styled, {css} from 'react-emotion'

const CustomModal = styled(Modal)`
  position: relative;

  .ant-modal-content {
    @media screen and (max-width: 420px) {
      margin: 0 !important;
    }

    .ant-modal-header {
      .ant-modal-title {
        text-align: center;
        color: black;
      }
    }
    .ant-modal-body {
      background: white;
      color: black;
      border-radius: 5px;
      padding: 0%;
    }
    .ant-modal-close {
      .ant-modal-close-x {
        display: none;
      }
    }
  }

  ${props =>
    responsive.tablet(css`
      width: auto !important;
      .ant-modal-content {
        margin: 0 10px;
      }
    `)};
`

const CustomIcon = styled(FontAwesomeIcon)`
  position: absolute;
  right: 16px;
  top: 12px;
  font-size: 25px;

  width: 25px !important;

  cursor: pointer;
  color: #7f7f7f;
  background-color: white;
  border-radius: 50%;
  border: 3px solid white;
  z-index: 99;
`

const ModalShare = ({
  onClose = () => {},
  onCancel = () => {},
  isShowModal,
  setIsShowModal,
  children,
  className,
  width = '600px',
}) => (
  <CustomModal
    className={className}
    visible={isShowModal}
    footer={null}
    width={width}
    onCancel={() => {
      onCancel()
      setIsShowModal(false)
      onClose()
    }}
    title={null}>
    <CustomIcon
      onClick={() => {
        onCancel()
        setIsShowModal(false)
        onClose()
      }}
      icon={['fas', 'times']}
    />
    {children}
  </CustomModal>
)

export default ModalShare
